export default {
    categories: {
        DOCUMENTATION: 'Documentación',
        CASE: 'Caso',
        ACCOUNT: 'Cuenta',
        OPERATION: 'Operación',
        OTHERS: 'Otros',
        OPERATION_OTHERS: 'Otros'
    },
    subcategories: {
        OTHERS: 'Otros',
        OPERATION_OTHERS: 'Otros',
        CUESTIONARIO_CONOCIMIENTO_PERSONA_FISICA: 'Cuestionario de Conocimiento Persona Física',
        DOCUMENTOS_FATCA_CRS_AEAT: 'Documentos Fatca, CRS, AEAT',
        DECLARACION_FATCA_CRS_AEAT: 'Declaración FACTA y CRS',
        DECLARACION_FATCA_CRS_AEAT_ASOCIADO_PATRONO: 'Declaración FATCA y CRS asociado/patrono',
        CERTIFICADO_CIUDADANO_UE: 'Certificado de registro de ciudadanos de la UE',
        DOCUMENTO_IDENTIFICATIVO_PF_ANVERSO: 'Fotocopias Documento identificativo (Anverso).',
        DOCUMENTO_IDENTIFICATIVO_PF_REVERSO: 'Fotocopias Documento identificativo (Reverso).',
        LIBRO_DE_FAMILIA: 'Fotocopia Libro de familia',
        APODERAMIENTO_SENTENCIA_JUDICIAL: 'Apoderamiento /sentencia judicial',
        DOCUMENTO_IDENTIFICATIVO_PJ: 'Fotocopias Documento identificativo.',
        CUESTIONARIO_CONOCIMIENTO_PERSONA_JURIDICA: 'Cuestionario de Conocimiento Persona Jurídica',
        DECLARACION_FATCA_CRS_SOCIEDAD: 'Declaración FACTA y CRS de la Sociedad',
        MODELO_KYC: 'Estructura accionarial (modelo KYC)',
        CONSTITUCION_Y_ESTATOS: 'Escritura de constitución y estatutos vigentes',
        ALTA_DE_CLIENTE_FI: 'Alta de cliente FI',
        CLAUSULADO_ALTA_DE_CLIENTE: 'Clausulado Alta de cliente',
        DFI: 'DFI (actualizado de oficio)',
        DFI_COBAS_CONCENTRADOS_FIL: 'DFI Cobas Concentrados Fil',
        DFI_COBAS_SELECCION: 'DFI Cobas Selección',
        DFI_COBAS_INTERNACIONAL: 'DFI Cobas Internacional',
        DFI_COBAS_IBERIA: 'DFI Cobas Iberia',
        DFI_COBAS_GRANDES_COMPANIAS: 'DFI Cobas Grandes Compañías',
        DFI_COBAS_RENTA: 'DFI Cobas Renta',
        DFI_COBAS_GLOBAL: 'DFI Cobas Global',
        DFI_COBAS_MIXTO_GLOBAL: 'DFI Cobas Mixto Global',
        ANEXO_AL_DFI: 'Anexo al DFI',
        AUTORIZACION_A_TERCEROS: 'Autorización a terceros',
        TEST_DE_CONVENIENCIA: 'Test de conveniencia',
        EVALUACION_CONVENIENCIA: 'Evaluación conveniencia',
        EVALUACION_CONVENIENCIA_CONCENTRADOS: 'Evaluación conveniencia Concentrados',
        INFORME_SEMESTRAL: 'Informe Semestral (actualizado en fecha publicación CNMV)',
        INFORME_SEMESTRAL_COBAS_CONCENTRADOS_FIL: 'Informe Semestral Cobas Concentrados Fil',
        INFORME_SEMESTRAL_COBAS_SELECCION: 'Informe Semestral Cobas Selección',
        INFORME_SEMESTRAL_COBAS_INTERNACIONAL: 'Informe Semestral Cobas Internacional',
        INFORME_SEMESTRAL_COBAS_IBERIA: 'Informe Semestral Cobas Iberia',
        INFORME_SEMESTRAL_COBAS_GRANDES_COMPANIAS: 'Informe Semestral Cobas Grandes Compañías',
        INFORME_SEMESTRAL_COBAS_RENTA: 'Informe Semestral Cobas Renta',
        INFORME_SEMESTRAL_COBAS_GLOBAL: 'Informe Semestral Cobas Global',
        INFORME_SEMESTRAL_COBAS_MIXTO_GLOBAL: 'Informe Semestral Cobas Mixto Global',
        BOLETIN_ADHESION_FP: 'Boletín adhesión FP',
        CLAUSULADO_BOLETÍN_ADHESIÓN_FP: 'Clausulado Boletín adhesión FP',
        APORTANTE_PP: 'Aportante PP',
        DFP: 'DFP (actualizado)',
        DFP_GLOBAL: 'DFP Cobas Global',
        DFP_MIXTO_GLOBAL: 'DFP Cobas Mixto Global',
        DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC:
            'Documento acreditativo titularidad cuenta corriente',
        EEPP: 'EEPP (traspasos)',
        ESPANOL_NO_RESIDENTE:
            'Español No residente. Certificado de residencia fiscal o Consulado (reembolsos)',
        EXTRANJERO_NO_RESIDENTE:
            'Extranjero no residente, certificación negativa de residencia en España (reembolsos)',
        SOLICITUD_DE_APORTACION_FP: 'Solicitud de aportación FP',
        SOLICITUD_DE_TRASLADO_DC_DE_FP: 'Solicitud de traslado DC DE FP',
        ORDEN_DE_SUSCRIPCIONS_TRASPASO_FI: 'Orden de suscripción-es traspaso-s FI',
        CLAUSULADO_ORDEN_DE_SUSCRIPCION_TRASPASO_FI:
            'Clausulado Orden de suscripción-es traspaso-s FI',
        IDENTIFICACION_ESTRUCTURA_DE_PROPIEDAD_Y_CONTROL:
            'Todas las sociedades y SICAV, excepto cotizadas. Identificación estructura de propiedad y control (25% acciones) persona física final, en caso de no existir, administrador-es.',
        ESCRITURAS_DE_PODERES: 'Escrituras de poderes de los representantes firmantes',
        CARTULINA_DE_FIRMAS_APODERAMIENTO:
            'Cartulina de firmas apoderamiento, representantes/apoderados (legales) En el caso de entidades financieras, cartulian de firmas de los apoderados (ver persona física)',
        ORDEN_DE_SUSCRIPCION: 'Orden de suscripción-es',
        CLAUSULADO_ORDEN_DE_SUSCRIPCION: 'Clausulado Orden de suscripción-es',
        OPERATION_TICKET: 'Boleta',
        OPERATION_RECEIPT: 'Recibo de la operación',
        ESCRITURA_CONSTITUCION: 'Escritura de constitución',
        ESTATUTOS_VIGENTES: 'Estatutos vigentes',
        ESTRUCTURA_ACCIONARIAL: 'Estructura Accionarial',
        CERTIFICADO_SECRETARIO_CONSEJO_ADMINISTRACION:
            'Certificado secretario consejo administración',
        ESCRITURA_O_ACTA_DE_CONSTITUCION: 'Escritura o acta de constitución',
        ARTICLES_OF_ASSOCIATION: 'Articles of association',
        ACREDITACION_CAMBIO_DIRECCION_FISCAL: 'Acreditación de cambio de dirección fiscal',
        DOCUMENTACION_ACREDITATIVA_APORTANTE_CONYUGE:
            'Documentación acreditativa aportante conyuge',
        DOCUMENTACION_ACREDITATIVA_APORTANTE_DISCAPACITADO:
            'Documentación acreditativa aportante discapacitado',
        VIDEOIDENTIFICACION: 'Prueba de videoidentificación',
        DOCUMENTO_AUTORIZACION_ACCESO_INFORMACION:
            'Documento de autorización de acceso a información',
        FINAMETRIX: 'Documentación escaneada',
        NO_COBAS_RAW_DOCUMENTATION: 'Documentación escaneada',
        DOCUMENTACION_ACREDITATIVA_DISCAPACIDAD: 'Certificado Discapacidad',
        TEST_KYC_ASOCIADO_PATRONO: 'Cuestionario de Conocimiento Asociado/Patrono',
        CONSENTIMIENTO_INVERSOR: 'Consentimiento del inversor',
        SOLICITUD_INVERSION: 'Solicitud de inversión',
        IIFF_PP_APORTACIONES: 'Aportaciones',
        IIFF_PP_APORTACIONES_APORTANTES: 'Aportaciones',
        IIFF_PP_PRESTACIONES: 'Prestaciones',
        IIFF_PP: 'Informes fiscales (PP)',
        IIFF_FI: 'Informes fiscales (FI)',
        IIGG: 'Informe de gastos',
        COBAS_PLUS_ALTA: 'Cobas PLUS: Terminos y condiciones',
        DOCUMENTACION_ALTA_ONLINE: 'Documentación de alta'
    },
    signature_type: {
        INDISTINTA: 'Indistinta',
        CONJUNTA: 'Conjunta',
        MANCOMUNADA: 'Mancomunada',
        SOLIDARIA: 'Solidaria',
        MANCOMUNADA_CONDICIONADA: 'Mancomunada condicional'
    }
};
